import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

// If an admin has uploaded a custom favicon, swap it in. Falls back silently
// to the default green-dot SVG declared in index.html.
fetch('/api/uploads/favicon')
  .then(r => r.ok ? r.json() : null)
  .then(fav => {
    if (!fav || !fav.url) return;
    const link = document.getElementById('app-favicon');
    if (!link) return;
    link.setAttribute('type', fav.type || 'image/png');
    link.setAttribute('href', fav.url);
  })
  .catch(() => {});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
